
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.063 23.531c.421.657 1.406.657 1.828 0C16.734 13.688 18 12.656 18 9c0-4.969-4.031-9-9-9-5.016 0-9 4.031-9 9 0 3.656 1.219 4.688 8.063 14.531zM9 12.75c-2.11 0-3.75-1.64-3.75-3.75 0-2.063 1.64-3.75 3.75-3.75A3.761 3.761 0 0112.75 9c0 2.11-1.688 3.75-3.75 3.75z","fill":"currentColor"}})])
          )
        }
      }
    